<div class="admin-tab-client" data-testid="admin-tab-client-container">
  <div class="admin-tab-client__header">
    <h2 class="admin-tab-client__title">My Clients</h2>

    @if (!isLoading && !error && clients && clients.length > 0) {
    <button class="admin-tab-client__create-button" type="button" (click)="onCreateClient()" data-testid="admin-tab-client-create-button">
      + Add Client
    </button>
    }
  </div>

  <div class="admin-tab-client__content">
    <!-- Loading State -->
    @if (isLoading) {
    <div class="admin-tab-client__loading" data-testid="clients-loading">
      <mat-spinner diameter="40"></mat-spinner>
      <p class="admin-tab-client__loading-text">Loading clients...</p>
    </div>
    } @else if (error) {
    <div class="admin-tab-client__error" data-testid="clients-error">
      <div class="admin-tab-client__error-banner">
        <mat-icon class="admin-tab-client__error-icon">error</mat-icon>
        <div class="admin-tab-client__error-content">
          <p class="admin-tab-client__error-message">{{ error }}</p>
          <button mat-stroked-button color="primary" (click)="onRetryLoad()" class="admin-tab-client__retry-button">
            <mat-icon>refresh</mat-icon>
            Retry
          </button>
        </div>
      </div>
    </div>
    } @else if (clients?.length === 0) {
    <div class="admin-tab-client__empty" data-testid="clients-empty-state">
      <div class="admin-tab-client__empty-content">
        <mat-icon class="admin-tab-client__empty-icon">people_outline</mat-icon>
        <h3 class="admin-tab-client__empty-title">No clients yet.</h3>
        <p class="admin-tab-client__empty-body">Add your first client to generate a private link.</p>
        <button
          class="admin-tab-client__create-button"
          type="button"
          (click)="onCreateClient()"
          data-testid="admin-tab-client-create-button"
        >
          + Add Client
        </button>
      </div>
    </div>
    } @else {
    <!-- Client Cards Grid -->
    <div class="admin-tab-client__grid" data-testid="clients-list">
      @for (client of sortedClients; track client.id) {
        <wil-admin-tab-client-card [client]="client"></wil-admin-tab-client-card>
      }
    </div>
    }
  </div>
</div>
